import phoneframe from "../assets/phone_frame.png";
import macframe from "../assets/macframe.png";
import delcapo_web from "../assets/delcapo_web.png";
import delcapo_mobile from "../assets/delcapo_mobile.png";
import akk_mobile from "../assets/akk_mobile.png";
import akk_web from "../assets/akk_web.png";
import ars_web from "../assets/ars_web.png";
import ars_mobile from "../assets/ars_mobile.png";

import next_ecomm_mac from "../assets/next_ecomm_mac.png";
import next_ecomm_mobile from "../assets/next_ecomm_mobile.png";
import hexbox_web from "../assets/hexbox_web.png";
import hexbox_mobile from "../assets/hexbox_mobile.png";
const images = {
  delcapo_web,
  delcapo_mobile,
  next_ecomm_mac,
  next_ecomm_mobile,
  phoneframe,
  macframe,
  ars_web,
  ars_mobile,
  akk_mobile,
  akk_web,
  hexbox_web,
  hexbox_mobile,
};

export default images;
